module.exports = __webpack_public_path__ + "img/criba.4aa51305.jpg";